module.exports = __webpack_public_path__ + "img/android_tip.cd65a33f.png";